import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import EveningDetail from "@/pages/EveningDetail";
import MyBookings from "@/pages/MyBookings";
import HostApply from "@/pages/HostApply";
import HostDashboard from "@/pages/HostDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) { el.scrollIntoView({ behavior: "smooth" }); return; }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-parchment">
      <Nav />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Layout><Landing /></Layout>} />
        <Route path="/evenings/:id" element={<Layout><EveningDetail /></Layout>} />
        <Route path="/bookings" element={<Layout><MyBookings /></Layout>} />
        <Route path="/host" element={<Layout><HostApply /></Layout>} />
        <Route path="/host/dashboard" element={<Layout><HostDashboard /></Layout>} />
        <Route path="/admin" element={<Layout><AdminDashboard /></Layout>} />
        <Route path="/payment/success" element={<Layout><PaymentSuccess /></Layout>} />
      </Routes>
      <Toaster position="top-center" />
    </BrowserRouter>
  );
}

export default App;
